module.exports = __webpack_public_path__ + "img/Flag_of_Palau.2104cf16.svg";